import styled from "styled-components";
import { ToggleSelect } from "@loanbossinc/component-library";

export const OuterWrapper = styled.div`
  background: #FFFFFF;
  border: 1px solid;
  border-color: ${props => (props.isPrivate ? "#DADCE0" : "#0F9AD6")}
  box-sizing: border-box;
  border-radius: 8px;

  &:hover {
    background-color: #f5f5f5
  }

  .item-header {
    padding: 24px;
  }

  .item-content {
    padding: 24px;
    padding-top: 0;
  }

  .item-actions {
    padding: 24px;
    border-top: 1px solid #DADCE0;
  }

  &:not(:first-child) {
    margin-top: 24px;
  }
`;

export const DeleteWrapper = styled.div`  
  float: right;
  cursor: pointer;
  color: #5F6368;
`;

const baseFont = styled.div`
  font-family: Work Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
`;

export const ContactWrapper = styled(baseFont)`
  font-weight: 500;  
  line-height: 19px;

  /* identical to box height */
  display: flex;
  align-items: flex-end;
  color: #000000;
`;

export const DateWrapper = styled(baseFont)`
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;

  /* identical to box height */
  display: flex;
  align-items: flex-end;
  text-transform: uppercase;

  /* Text / Dark Gray */
  color: #5F6368;
  margin-top:5px;
`;

export const NoteWrapper = styled(baseFont)`
  line-height: 19px;
  color: #000000;
`;

export const StyledToggleSelect = styled(ToggleSelect)`
  && {
    .Mui-selected {
      background-color: ${props => (props.isPrivate ? "#5F6368" : "#0F9AD6")}
      color: #fff;
    }
  }
`;
